"use client";

import { useTranslations } from "next-intl";
import NavigationComponent from "./navigation";
import { Link } from "@/i18n/routing";
import MainLogo from "../ui/logo";
import { Button } from "../ui/button";
import TopBanner from "./top-banner";
import MobileNavigation from "./mobile-navigation";
import { env } from "@/env";

export type UseCase = {
  title: string;
  link: string;
  description?: string;
};

type HeaderProps = {
  useCases: UseCase[];
};

export function Header({ useCases }: HeaderProps) {
  const t = useTranslations(); // Initialize the translation function

  const action = {
    title: t("header.actions.login.title"),
    link: env.NEXT_PUBLIC_DASHBOARD_URL + "/auth/login",
  };

  return (
    <header className="fixed top-0 z-50 w-full">
      <TopBanner />
      <div className="border-b bg-background">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-1">
              <MobileNavigation />
              {/* Logo Section */}
              <Link aria-label="Homepage - thunderproxy" href="/">
                <MainLogo />
              </Link>
            </div>
            <NavigationComponent useCases={useCases} />
            {/* Try Now Button */}
            <Button size="sm" className="rounded-full" asChild>
              <Link href={action.link!}>{action.title}</Link>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
